import _ from 'lodash'
import { createAction, createReducer } from 'redux-act'
import { baseUrl } from '../scripts/env';
import axios from 'axios'
import { getUser } from './app';

const REDUCER = 'sites'
const NS = `@@${REDUCER}/`

export const toggleColumn = createAction(`${NS}TOGGLE_COLUMN`)

export const fetchRequest = createAction(`${NS}FETCH_REQUEST`)
export const fetchSuccess = createAction(`${NS}FETCH_SUCCESS`)
export const fetchFailure = createAction(`${NS}FETCH_FAILURE`)

export const talkTypeRequest = createAction(`${NS}TALK_TYPE_REQUEST`)
export const talkTypeSuccess = createAction(`${NS}TALK_TYPE_SUCCESS`)
export const talkTypeFailure = createAction(`${NS}TALK_TYPE_FAILURE`)

export const selectRowKeys = createAction(`${NS}SELECT_ROW_KEYS`)

const initialState = {
    isLoading: false,
    items: [],
    selectedRowKeys: [],
    columnsEnabled: {
        id: true,
        name: true,
        created: false,
        have_installed_widgets: false,
        license_end: false,
        license_type: true,
        stats: false,
        total_amount: true,
        partner_reward_amount: true,
        partner_talk_type: false,
        client_invoice: true,
    }, 
    pagination: {
        current: 1,
        pageSize: 20,
        defaultPageSize: 20,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200']
    },
    lastSelectedTalkType: '',
}

export const fetch = input => async (dispatch) => {
    dispatch(fetchRequest())
    const params = _.mapValues(input, (value) => { return _.isArray(value) ? value[0] : value })
    const response = await axios({
        url: `${baseUrl}/${REDUCER}`,
        params
    });
  
    const pagination = _.get(response, 'data.pagination', false)
    const items = _.get(response, `data.${REDUCER}`, false)
    if (items === false || pagination === false) {
        dispatch(fetchFailure())
        return false
    }
    
    dispatch(fetchSuccess({items, pagination}))
    return true
}

export const setSiteTalkType = params => async (dispatch) => {
    dispatch(talkTypeRequest(params))
    const response = await axios({
        method: 'patch',
        url: `${baseUrl}/${REDUCER}`,
        params: {
            siteIds: params.siteIds,
            partnerTalkType: params.newStatus 
        }
    })
  
    if (_.get(response, 'data.ok', false) === false) {
        dispatch(talkTypeFailure(params))
        return false
    }
    
    dispatch(talkTypeSuccess(params))
    dispatch(getUser())
    return true
}

export default createReducer(
  {
    [toggleColumn]: (state, column) => ({ ...state, columnsEnabled: {...state.columnsEnabled, [column]: !state.columnsEnabled[column]} }),
    
    [fetchRequest]: (state) => ({ ...state, isLoading : true }),
    [fetchSuccess]: (state, data) => { 
        const items = data.items;
        const pagination = Object.assign(
            {}, 
            state.pagination, 
            _.mapKeys(data.pagination, (value, key) => { return _.camelCase(key) })
        );
        return { ...state, items, pagination, isLoading: false }
    },
    [fetchFailure]: (state, error) => ({ ...state, isLoading : false }),
    
    [talkTypeRequest]: (state, data) => { 
        const items = _.map(state.items, (item) => {
            if (_.includes(data.siteIds, item.id)){
                item.modifying = true
            }
            return item
        });
        return {...state, items}
    },
    [talkTypeSuccess]: (state, data) => { 
        const items = _.map(state.items, (item) => {
            if (_.includes(data.siteIds, item.id)){
                item.partner_talk_type = data.newStatus
                item.modifying = false
            }
            return item
        });
        const newState = {...state, items};
        if (data.isBulkSelector) {
            newState.lastSelectedTalkType = data.newStatus;
        }
        return newState;
    },
    [talkTypeFailure]: (state, data) => { 
        const items = _.map(state.items, (item) => {
            if (_.includes(data.siteIds, item.id)){
                item.partner_talk_type = data.oldStatus
                item.modifying = false
            }
            return item
        });
        return {...state, items}
    },

    [selectRowKeys]: (state, data) => { 
        const selectedRowKeys = data.selectedRowKeys
        return {...state, selectedRowKeys}
    },

  },
  initialState,
)



// WEBPACK FOOTER //
// ./src/ducks/sites.js